import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer" 

export default function RFQs() {
  const [rfqs, setRfqs] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [drawer, setDrawer] = useState(false);
  const [notes, setNotes] = useState("");
  const [status, setStatus] = useState("new");

  useEffect(() => {
    if (!localStorage.getItem("rfqs")) {
      localStorage.setItem(
        "rfqs",
        JSON.stringify([
          {
            id: "RFQ-1001",
            company: "Enterprise Corp",
            contact: "john@corp.com",
            date: "20 Jan 2026",
            items: ["S3400-48T6SP x20"],
            status: "new",
            notes: ""
          }
        ])
      );
    }
    setRfqs(JSON.parse(localStorage.getItem("rfqs")));
  }, []);

  const filtered = rfqs.filter(
    r =>
      r.id.toLowerCase().includes(search.toLowerCase()) ||
      r.company.toLowerCase().includes(search.toLowerCase())
  );

  const openDrawer = r => {
    setSelected(r);
    setNotes(r.notes || "");
    setStatus(r.status);
    setDrawer(true);
  };

  const updateRFQ = () => {
    const updated = rfqs.map(r =>
      r.id === selected.id ? { ...r, notes, status } : r
    );
    setRfqs(updated);
    localStorage.setItem("rfqs", JSON.stringify(updated));
    setDrawer(false);
  };

  const deleteRFQ = id => {
    if (!window.confirm("Delete RFQ?")) return;
    const updated = rfqs.filter(r => r.id !== id);
    setRfqs(updated);
    localStorage.setItem("rfqs", JSON.stringify(updated));
    setDrawer(false);
  };

  return (
    <div className="admin-body">
      <Topbar />
      <Sidebar />

      <main className="admin-main">
        <div className="dashboard-header">
          <h1>RFQ Management</h1>
          <input
            placeholder="Search RFQ / Company"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <section className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>RFQ ID</th>
                <th>Company</th>
                <th>Contact</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(r => (
                <tr key={r.id}>
                  <td data-label="RFQ ID">{r.id}</td>
                  <td data-label="Company">{r.company}</td>
                  <td data-label="Contact">{r.contact}</td>
                  <td data-label="Date">{r.date}</td>
                  <td data-label="Status">
                    <span className={`status ${r.status}`}>{r.status}</span>
                  </td>
                  <td data-label="Action">
                    <button className="icon-btn icon-view" onClick={() => openDrawer(r)}>👁</button>
                    <button className="icon-btn icon-edit" onClick={() => openDrawer(r)}>✏️</button>
                    <button className="icon-btn icon-delete" onClick={() => deleteRFQ(r.id)}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {drawer && selected && (
          <div className="drawer open">
            <div className="drawer-content">
              <h2>RFQ Details</h2>
              <p><b>ID:</b> {selected.id}</p>
              <p><b>Company:</b> {selected.company}</p>
              <p><b>Contact:</b> {selected.contact}</p>

              <label>Notes</label>
              <textarea value={notes} onChange={e => setNotes(e.target.value)} />

              <label>Status</label>
              <select value={status} onChange={e => setStatus(e.target.value)}>
                <option>new</option>
                <option>in-review</option>
                <option>quoted</option>
                <option>closed</option>
              </select>

              <div className="drawer-actions">
                <button className="primary" onClick={updateRFQ}>Update</button>
                <button className="danger" onClick={() => deleteRFQ(selected.id)}>Delete</button>
                <button onClick={() => setDrawer(false)}>Close</button>
              </div>
            </div>
          </div>
        )}
      </main>
      <Footer/>
    </div>
  );
}
